// @ts-nocheck
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '@/lib/analytics';

export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);
};

export { 
  logEvent,
  trackEventRegistration,
  trackAthleteImport,
  trackQRDownload,
  trackProfileView,
  trackCoachInvitation,
  trackMembershipPurchase,
  trackFormSubmission,
  trackSearch,
  trackEmailSent,
  trackFileUpload
} from '@/lib/analytics';
